var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form-model", {
    ref: "ruleForm",
    staticStyle: {
      position: "relative"
    },
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("cookie弹窗")))]), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("文件内容"),
      prop: "fileContent"
    }
  }, [_c("quill-editor", {
    ref: "myTextEditor1",
    staticStyle: {
      height: "540px"
    },
    attrs: {
      options: _vm.quillOption,
      disabled: !_vm.isEdit
    },
    model: {
      value: _vm.form.fileContent,
      callback: function ($$v) {
        _vm.$set(_vm.form, "fileContent", $$v);
      },
      expression: "form.fileContent"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("链接文件")
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      "justify-content": "space-between"
    }
  }, [_c("a-select", {
    staticStyle: {
      flex: "1",
      overflow: "hidden"
    },
    attrs: {
      "show-search": "",
      placeholder: _vm.$t("请选择") + _vm.$t("链接文件"),
      "option-filter-prop": "children",
      allowClear: true,
      disabled: !_vm.isEdit
    },
    on: {
      change: _vm.fileChange,
      dropdownVisibleChange: _vm.getSystemConfigFileList
    },
    model: {
      value: _vm.fileId,
      callback: function ($$v) {
        _vm.fileId = $$v;
      },
      expression: "fileId"
    }
  }, _vm._l(_vm.fileList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id,
        label: item.name
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1), _c("a-button", {
    staticClass: "copyBtn",
    attrs: {
      size: "small",
      disabled: !_vm.isEdit
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.handleCopy(`${_vm.fileId}`, $event);
      }
    }
  }, [_c("a-icon", {
    attrs: {
      type: "copy"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("复制链接")) + " ")], 1)], 1)]), _c("div", {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("个性化设置")))]), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("文件内容"),
      prop: "content"
    }
  }, [_c("quill-editor", {
    ref: "myTextEditor2",
    staticStyle: {
      height: "540px"
    },
    attrs: {
      options: _vm.quillOption,
      disabled: !_vm.isEdit
    },
    model: {
      value: _vm.form.content,
      callback: function ($$v) {
        _vm.$set(_vm.form, "content", $$v);
      },
      expression: "form.content"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("链接文件")
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      "justify-content": "space-between"
    }
  }, [_c("a-select", {
    staticStyle: {
      flex: "1",
      overflow: "hidden"
    },
    attrs: {
      "show-search": "",
      placeholder: _vm.$t("请选择") + _vm.$t("链接文件"),
      "option-filter-prop": "children",
      allowClear: true,
      disabled: !_vm.isEdit
    },
    on: {
      change: _vm.fileChange,
      dropdownVisibleChange: _vm.getSystemConfigFileList
    },
    model: {
      value: _vm.fileId1,
      callback: function ($$v) {
        _vm.fileId1 = $$v;
      },
      expression: "fileId1"
    }
  }, _vm._l(_vm.fileList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id,
        label: item.name
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1), _c("a-button", {
    staticClass: "copyBtn",
    attrs: {
      size: "small",
      disabled: !_vm.isEdit
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.handleCopy(`${_vm.fileId1}`, $event);
      }
    }
  }, [_c("a-icon", {
    attrs: {
      type: "copy"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("复制链接")) + " ")], 1)], 1)]), _c("div", {
    staticClass: "btnhandles"
  }, [_vm.btnShow === 1 || _vm.isEdit === true ? _c("a-button", {
    attrs: {
      type: "primary",
      disabled: _vm.disableBtn
    },
    on: {
      click: _vm.saveForm
    }
  }, [_vm._v(_vm._s(_vm.$t("保存")))]) : _vm._e(), _vm.btnShow === 2 && _vm.isEdit === false ? _c("a-button", {
    attrs: {
      type: "edit"
    },
    on: {
      click: _vm.editForm
    }
  }, [_vm._v(_vm._s(_vm.$t("编辑")))]) : _vm._e(), _vm.btnShow === 3 && _vm.isEdit === true ? _c("a-button", {
    on: {
      click: _vm.cancelForm
    }
  }, [_vm._v(_vm._s(_vm.$t("取消")))]) : _vm._e()], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };